import React from 'react';
import ReactDOM from 'react-dom/client';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);

if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((error) => {
      console.error('Service worker registration failed:', error);
    });
  });
}

const renderStartupError = (message: string) => {
  root.render(
    <React.StrictMode>
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '24px',
        background: '#f8fafc',
        fontFamily: 'system-ui, sans-serif',
      }}>
        <div style={{
          maxWidth: '640px',
          width: '100%',
          background: '#ffffff',
          border: '1px solid #fecaca',
          borderRadius: '16px',
          padding: '24px',
          boxShadow: '0 10px 30px rgba(15, 23, 42, 0.08)',
        }}>
          <p style={{
            margin: 0,
            fontSize: '12px',
            fontWeight: 800,
            letterSpacing: '0.12em',
            textTransform: 'uppercase',
            color: '#dc2626',
          }}>
            Startup Error
          </p>
          <h1 style={{
            margin: '12px 0 8px',
            fontSize: '28px',
            lineHeight: 1.2,
            color: '#111827',
          }}>
            SideGigs could not start
          </h1>
          <p style={{
            margin: 0,
            fontSize: '15px',
            lineHeight: 1.7,
            color: '#4b5563',
            whiteSpace: 'pre-wrap',
          }}>
            {message}
          </p>
        </div>
      </div>
    </React.StrictMode>
  );
};

const recoverFromStalePwa = async (error: unknown) => {
  if (!import.meta.env.PROD || !('serviceWorker' in navigator) || !('caches' in window)) return false;
  const message = error instanceof Error ? error.message : String(error || '');
  const looksLikeStaleAsset = /MIME type|dynamically imported module|Failed to fetch|Importing a module script failed/i.test(message);
  const recoveryKey = 'sidegigs-pwa-recovery-v1';
  if (!looksLikeStaleAsset || sessionStorage.getItem(recoveryKey) === 'attempted') return false;

  sessionStorage.setItem(recoveryKey, 'attempted');
  const registrations = await navigator.serviceWorker.getRegistrations();
  await Promise.all(registrations.map((registration) => registration.unregister()));
  const cacheNames = await caches.keys();
  await Promise.all(cacheNames.filter((name) => name.startsWith('sidegigs-pwa-')).map((name) => caches.delete(name)));
  window.location.reload();
  return true;
};

import('./App')
  .then(({ default: App }) => {
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  })
  .catch(async (error) => {
    console.error('Startup Error:', error);
    if (await recoverFromStalePwa(error)) return;
    renderStartupError(
      error instanceof Error
        ? error.message
        : 'An unexpected startup error occurred. Check your Firebase and frontend environment variables.'
    );
  });
